import React, {
  useState,
  Fragment,
  useRef,
  useEffect,
  useCallback,
  memo,
} from 'react';
import styled from 'styled-components';
import { Title2 } from '../../../components/Typography';
import {
  ORDER_REFUNDED,
  ORDER_REJECTED,
  ORDER_SUBMITTED,
  ORDER_ACCEPTED,
  ORDER_COMPLETE,
  ORDER_ON_DELIVERY,
  ORDER_READY_TO_PICKUP,
  ORDER_OUT_FOR_DELIVERY,
  ORDER_DELIVERED,
} from '../orderStatusTypes';
import OrderStatusModal1 from './OrderStatusModal1';
import { FlatButton } from '../../../components/Buttons';
import FeedbackModal from './FeedbackModal';
import Icon from './Icon';
import Slider from 'react-slick';
import appConfig from '../../../../app-config';
import {
  DELIVERY,
  PICKUP,
  DROPOFF,
} from '../../OrderSetting/orderSettingTypes';
import moment from 'moment';
import TrackButton from './TrackButton';
import calculateOrderReadyTime from '../utils/calculateOrderReadyTime';
const NextArrow = styled.div`
  @media (max-width: 1100px) {
    right: 10px !important;
  }
  @media (orientation: landscape) and (max-width: 1100px) {
    right: -20px !important;
  }
  @media (max-width: 786px) {
    display: none !important;
  }
`;

const PrevArrow = styled.div`
  @media (max-width: 786px) {
    display: none !important;
  }
`;

const Separator = styled.div`
  width: 3em;
  height: 4px;
  border-radius: 2px;
  background-color: #b4c3db;
  margin: 0px 1em 0px 1em;
`;

const OrderStatusContainer = styled.div`
  width: 532px;
  max-height: 400px;
  @media only screen and (min-width: 768px) {
    width: 450px;
  }
  @media (max-width: 480px) {
    max-width: 340px;
    max-height: 410px;
  }
`;
const OrderStatusWrapper = styled.div`
  position: relative;
  width: 532px;
  height: 266px;
  padding: 16px 24px 52px;
  background: ${(props) => props.theme.orderStatusBackgroundColor};
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 10px;
  cursor: ${(props) => !props.isForModal && 'pointer'};
  justify-content: center;
  &:hover {
    background: ${(props) =>
      !props.isForModal && props.theme.orderStatusBackgroundColorHover};
    background-repeat: no-repeat;
    background-size: cover;
    transition: all 0.25s ease;
  }
  @media only screen and (min-width: 768px) {
    width: 450px;
    margin: 15px 0;
  }
  @media (max-width: 480px) {
    max-width: 340px;
    margin: 15px 0;
    height: 220px;
  }
`;
const FeedbackWrapper = styled.div`
  width: 100%;
  border-radius: 12px;
  padding: 12px 16px;
  background: #f7f7f7;
  grid-gap: 12px;
  display: grid;
  grid-template-columns: 0.7fr 0.3fr;
  margin: 15px 0;
  @media only screen and (min-width: 768px) {
    width: 450px;
  }
  @media (max-width: 480px) {
    display: block;
    max-width: 340px;
    margin-bottom: 20px;
  }
`;
const RateTextWrapper = styled.div`
  display: grid;
  grid-template-columns: 30px 1fr;
`;
const ButtonWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  @media (max-width: 480px) {
    margin-top: 10px;
  }
`;
const Wrapper = styled.div`
  margin: 32px auto 0 0;
  max-width: 480px;
`;

const ContentWrapper = styled.div`
  position: absolute;
  left: 25px;
  bottom: 25px;
  @media (max-width: 479px) {
    padding: 5px;
  }
`;

const Content = styled.div`
  padding: 10px 0px;
  @media (max-width: 480px) {
    margin: 0;
  }
`;

const Title = styled(Title2)`
  color: ${(props) => props.theme.orderStatusTitleColor};
  margin-bottom: 10px;
`;

const Button = styled(FlatButton)`
  border-radius: 17.5px;
  padding: 7px 16px;
  background: ${(props) => props.theme.primaryButtonBackgroundColor};
  color: ${(props) => props.theme.primaryButtonFontColor};

  &:hover {
    background: ${(props) => props.theme.primaryButtonHoverColor};
    transition: all 0.25s ease;
  }
`;

const OrderStatusMessage = styled.div`
  font-size: ${(props) => props.theme.orderStatusMessageFontSize || '16px'};
  padding-right: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  white-space: pre-wrap;
  font-family: ${(props) => props.font || ''};
  color: ${(props) => props.customColor || 'black'};
  @media (max-width: 480px) {
    text-overflow: ellipsis;
    max-height: 100px;
    overflow: hidden !important;
    font-size: 13px;
  }
`;

const OrderStatusSubMessage = styled.div`
  font-size: ${(props) => props.theme.orderStatusSubMessageFontSize || '14px'};
  margin: 8px 0 0;
  margin-right: 25px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.01px;
  white-space: pre-wrap;
  font-family: ${(props) => props.font || ''};
  color: ${(props) => props.customColor || '#737a87'};
  @media (max-width: 480px) {
    text-overflow: ellipsis;
    max-height: 100px;
    overflow: hidden !important;
    font-size: 10px;
  }
`;
const OrderPlacedTimeWrapper = styled.div`
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  padding-left: 5px;
`;
const isOrderWithFirebaseUrl = (orderHistory, orderStatus) => {
  const orderHist = orderHistory.filter(
    (order) => order.order_id == orderStatus.orderId
  );

  if (orderHist[0]?.firebase_uri && orderHist[0]?.firebase_uri?.length !== 0) {
    return true;
  } else {
    return false;
  }
};
const SlideWrap = styled.div`
  margin-top: 10px;
  .slick-slide {
    padding: 0;
    margin-right: 10px;
  }
  .slick-list {
    margin: 0;
  }
  @media (min-width: 1800px) {
    .slick-list {
      min-width: 1600px !important;
    }
  }
  @media (min-width: 1550px) {
    .slick-list {
      min-width: 1470px !important;
    }
  }
  @media (min-width: 1400px) {
    .slick-list {
      min-width: 1170px !important;
    }
  }
  @media (orientation: landscape) and (max-width: 1100px) {
    .slick-list {
      width: 1255px !important;
    }
  }
`;
function OrderHistoryNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <NextArrow
      className={className}
      style={{
        ...style,
        display: 'block',
        background: '#fff',
        borderRadius: '50%',
        border: 'none',
        height: '40px',
        width: '40px',
        boxShadow: ' 0 2px 5px 0 rgba(59, 76, 112, 0.24)',
        top: props.feedbackRef.current ? '35%' : '45%',
        // right: '-10px',
        opacity: 1,
        fontSize: '16px',
        lineHeight: '40px',
        textAlign: 'center',
      }}
      onClick={onClick}
    />
  );
}

function OrderHistoryPrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <PrevArrow
      className={className}
      style={{
        ...style,
        display: 'block',
        background: '#fff',
        borderRadius: '50%',
        border: 'none',
        height: '40px',
        width: '40px',
        boxShadow: ' 0 2px 5px 0 rgba(59, 76, 112, 0.24)',
        top: props.feedbackRef.current ? '35%' : '45%',
        // left: '-20px',
        opacity: 1,
        lineHeight: '40px',
        textAlign: 'center',
        zIndex: '1',
      }}
      onClick={onClick}
    />
  );
}
const slideSettings = (feedbackRef) => {
  return {
    dots: false,
    infinite: false,
    speed: 600,
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    swipeToSlide: true,
    variableWidth: true,
    nextArrow: <OrderHistoryNextArrow feedbackRef={feedbackRef} />,
    prevArrow: <OrderHistoryPrevArrow feedbackRef={feedbackRef} />,
    rows: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          rows: 1,
          nextArrow: <OrderHistoryNextArrow feedbackRef={feedbackRef} />,
          prevArrow: <OrderHistoryPrevArrow feedbackRef={feedbackRef} />,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 1.7,
          slidesToScroll: 1,
          rows: 1,
          nextArrow: <OrderHistoryNextArrow feedbackRef={feedbackRef} />,
          prevArrow: <OrderHistoryPrevArrow feedbackRef={feedbackRef} />,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 1,
          nextArrow: <OrderHistoryNextArrow feedbackRef={feedbackRef} />,
          prevArrow: <OrderHistoryPrevArrow feedbackRef={feedbackRef} />,
        },
      },
    ],
  };
};
const SliderWrapper = ({ isMultiple, feedbackRef, children }) => {
  if (!isMultiple) {
    return <Wrapper>{children}</Wrapper>;
  }
  return (
    <SlideWrap>
      <Slider {...slideSettings(feedbackRef)}>{children}</Slider>
    </SlideWrap>
  );
};

const OrderStatus1 = ({
  orderStatusList,
  sendReview,
  feedbackModalIsVisible,
  openFeedbackModal,
  closeFeedbackModal,
  currency,
  is_tip_enabled,
  orderHistory,
  timeList,
  setTimeList,
  isFavoriteOpen,
  setIsFavoriteOpen,
  locations,
  feedbackModalData,
  setFeedbackModalData,
  orderStatusModalData,
  setOrderStatusModalData,
  displayComplete,
  setDisplayComplete,
}) => {
  const feedbackRef = useRef();
  const isMultiple = orderStatusList.length > 1;

  useEffect(() => {
    let newTimeList = [...timeList];
    const timer = setInterval(() => {
      orderStatusList.forEach((order, index) => {
        if (order.status === 2 || order.status === 5) {
          if (timeList.length > 0) {
            var duration = moment.duration(
              moment().diff(calculateOrderReadyTime(order))
            );
            var minutes = Math.round(duration.asMinutes());
            if (minutes > 29 && !orderStatusModalData && !isFavoriteOpen) {
              newTimeList[index].displayComplete = true;
              setTimeList(newTimeList);
            } else if (
              minutes < 30 &&
              !orderStatusModalData &&
              !isFavoriteOpen &&
              newTimeList[index].displayComplete
            ) {
              newTimeList[index].displayComplete = false;
              setTimeList(newTimeList);
            }
          }
        }
      });
    }, 5000);
    return () => {
      clearInterval(timer);
    };
  }, [orderStatusList]);
  const RenderOrderCompleteIcon = ({ orderType, status }) => {
    if (orderType === PICKUP)
      return (
        <>
          {appConfig.styleConfig.orderStatusStep3Icon ? (
            <img src={appConfig.styleConfig.orderStatusStep3Icon} />
          ) : (
            <>
              {status === ORDER_READY_TO_PICKUP ? (
                <Icon className='fas fa-store' />
              ) : (
                <Icon className='fal fa-store' />
              )}
            </>
          )}
        </>
      );

    if (orderType === DELIVERY)
      return (
        <>
          {appConfig.styleConfig.orderStatusStep3IconDelivery ? (
            <img src={appConfig.styleConfig.orderStatusStep3IconDelivery} />
          ) : (
            <>
              {status === ORDER_ON_DELIVERY ||
              status === ORDER_OUT_FOR_DELIVERY ? (
                <Icon className='fas fa-car-side' />
              ) : (
                <Icon className='fas fa-badge-check' />
              )}
            </>
          )}
        </>
      );

    if (orderType === DROPOFF)
      return (
        <>
          {appConfig.styleConfig.orderStatusStep3IconDropoff ? (
            <img src={appConfig.styleConfig.orderStatusStep3IconDropoff} />
          ) : (
            <>
              {status === ORDER_COMPLETE ? (
                <Icon className='fas fa-shopping-bag' />
              ) : (
                <Icon className='fal fa-shopping-bag' />
              )}
            </>
          )}
        </>
      );
  };

  const OrderStatusBody = ({
    orderType,
    status,
    businessName,
    orderReadyTime,
    deliveryTrackingURL,
    delay,
    index,
    statusMessage,
    isFutureOrder,
    minPrepTime,
  }) => {
    return (
      <ContentWrapper>
        {status === ORDER_COMPLETE &&
          timeList[index] &&
          timeList[index].displayComplete && (
            <Content>
              {appConfig.styleConfig.orderStatusStep3Icon &&
              orderType === 'pickup' ? (
                <img src={appConfig.styleConfig.orderStatusStep3Icon} />
              ) : appConfig.styleConfig.orderStatusStep3IconDelivery &&
                orderType === 'delivery' ? (
                <img src={appConfig.styleConfig.orderStatusStep3IconDelivery} />
              ) : (
                <Icon className='fas fa-badge-check' />
              )}
            </Content>
          )}
        {(status === ORDER_REFUNDED || status === ORDER_REJECTED) && (
          <Content>
            <Icon className='fas fa-exclamation-triangle' />
          </Content>
        )}
        {status === ORDER_SUBMITTED && (
          <Content>
            {appConfig.styleConfig.orderStatusStep1Icon &&
            orderType === 'pickup' ? (
              <img src={appConfig.styleConfig.orderStatusStep1Icon} />
            ) : appConfig.styleConfig.orderStatusStep1IconDelivery &&
              orderType === 'delivery' ? (
              <img src={appConfig.styleConfig.orderStatusStep1IconDelivery} />
            ) : (
              <Icon className='fas fa-check-circle' />
            )}
          </Content>
        )}
        {status === ORDER_ACCEPTED && (
          <Content>
            {appConfig.styleConfig.orderStatusStep2Icon &&
            orderType === 'pickup' ? (
              <img src={appConfig.styleConfig.orderStatusStep2Icon} />
            ) : appConfig.styleConfig.orderStatusStep2IconDelivery &&
              orderType === 'delivery' ? (
              <img src={appConfig.styleConfig.orderStatusStep2IconDelivery} />
            ) : (
              <Icon className='fas fa-hat-chef' />
            )}
          </Content>
        )}
        {(status === ORDER_ON_DELIVERY ||
          status === ORDER_READY_TO_PICKUP ||
          status === ORDER_OUT_FOR_DELIVERY ||
          status === ORDER_DELIVERED) && (
          // timeList[index] &&
          // !timeList[index].displayComplete &&
          <Content>
            <RenderOrderCompleteIcon orderType={orderType} status={status} />
          </Content>
        )}

        {appConfig.styleConfig.isStaticOrderStatus ? (
          <>
            <OrderStatusMessage
              customColor={appConfig.styleConfig.orderStatusTitleColor}
              font={appConfig.styleConfig.orderStatusMessageFont}
            >
              {(status === ORDER_REFUNDED || status === ORDER_REJECTED) && (
                <>
                  {
                    'Unfortunately, we cannot fulfill your order at this time. Your order will be refunded.'
                  }
                </>
              )}
              {orderType === 'pickup' &&
                status !== ORDER_REFUNDED &&
                status !== ORDER_REJECTED && (
                  <>
                    {isFutureOrder
                      ? appConfig.styleConfig.orderStatusPickupFutureMessage
                      : appConfig.styleConfig.orderStatusPickupASAPMessage}
                  </>
                )}
              {orderType === 'delivery' &&
                status !== ORDER_REFUNDED &&
                status !== ORDER_REJECTED && (
                  <>
                    {isFutureOrder
                      ? appConfig.styleConfig.orderStatusDeliveryFutureMessage
                      : appConfig.styleConfig.orderStatusDeliveryASAPMessage}
                  </>
                )}
              {orderType === 'drop_off' &&
                status !== ORDER_REFUNDED &&
                status !== ORDER_REJECTED && (
                  <>
                    {isFutureOrder
                      ? appConfig.styleConfig.orderStatusDropOffFutureMessage
                      : appConfig.styleConfig.orderStatusDropOffASAPMessage}
                  </>
                )}
            </OrderStatusMessage>
            <OrderStatusSubMessage
              customColor={appConfig.styleConfig?.orderStatusSubtitleColor}
              font={appConfig.styleConfig?.orderStatusMessageFont}
            >
              {orderType === 'pickup' &&
                status !== ORDER_REFUNDED &&
                status !== ORDER_REJECTED && (
                  <>
                    {!isFutureOrder &&
                      appConfig.styleConfig.orderStatusPickupASAPMessage2 &&
                      `${appConfig.styleConfig.orderStatusPickupASAPMessage2} ${minPrepTime} minutes`}
                    {isFutureOrder &&
                      appConfig.styleConfig.orderStatusPickupFutureMessage2}
                  </>
                )}
              {orderType === 'delivery' &&
                status !== ORDER_REFUNDED &&
                status !== ORDER_REJECTED && (
                  <>
                    {!isFutureOrder &&
                      appConfig.styleConfig.orderStatusDeliveryASAPMessage2 &&
                      `${appConfig.styleConfig.orderStatusDeliveryASAPMessage2} ${minPrepTime} minutes`}
                    {isFutureOrder &&
                      appConfig.styleConfig.orderStatusDeliveryFutureMessage2}
                  </>
                )}
            </OrderStatusSubMessage>
          </>
        ) : (
          <OrderStatusMessage
            customColor={appConfig.styleConfig.orderStatusTitleColor}
            font={appConfig.styleConfig.orderStatusMessageFont}
          >
            {status === ORDER_SUBMITTED ? (
              <>
                {appConfig.appSource === 'maker'
                  ? "Your order has been received. We'll update you once we start preparing it!"
                  : 'Your order has been placed'}
                <OrderStatusSubMessage
                  customColor={appConfig.styleConfig.orderStatusSubtitleColor}
                  font={appConfig.styleConfig.orderStatusMessageFont}
                >
                  {appConfig.appSource !== 'maker' &&
                    'Waiting for restaurant confirmation…'}
                </OrderStatusSubMessage>
              </>
            ) : status === ORDER_ACCEPTED && delay === 0 ? (
              <>
                Your order is being prepared
                <OrderStatusSubMessage
                  customColor={appConfig.styleConfig.orderStatusSubtitleColor}
                  font={appConfig.styleConfig.orderStatusMessageFont}
                >
                  {`It will be ready by ${orderReadyTime}`}
                </OrderStatusSubMessage>
              </>
            ) : status === ORDER_ACCEPTED && delay > 0 ? (
              <>
                Your order is being prepared
                <OrderStatusSubMessage
                  customColor={appConfig.styleConfig.orderStatusSubtitleColor}
                  font={appConfig.styleConfig.orderStatusMessageFont}
                >
                  {`It will be ready by ${orderReadyTime}. Please contact the store for more information.`}
                </OrderStatusSubMessage>
              </>
            ) : status === ORDER_READY_TO_PICKUP &&
              orderType === 'pickup' &&
              timeList[index] &&
              !timeList[index].displayComplete ? (
              <>
                Your order is ready for pickup
                <OrderStatusSubMessage
                  customColor={appConfig.styleConfig.orderStatusSubtitleColor}
                  font={appConfig.styleConfig.orderStatusMessageFont}
                >
                  {`at ${businessName}`}
                </OrderStatusSubMessage>
              </>
            ) : (status === ORDER_ON_DELIVERY ||
                status === ORDER_OUT_FOR_DELIVERY ||
                status === ORDER_DELIVERED) &&
              orderType === 'delivery' &&
              timeList[index] &&
              !timeList[index].displayComplete ? (
              <>
                {status === ORDER_DELIVERED ? (
                  <div>
                    Your order has been delivered
                    <div style={{ marginTop: '25px' }}>
                      <TrackButton deliveryTrackingURL={deliveryTrackingURL} />
                    </div>
                  </div>
                ) : (
                  <>
                    Your order is out for delivery
                    {deliveryTrackingURL ? (
                      <div style={{ marginTop: '25px' }}>
                        <TrackButton
                          deliveryTrackingURL={deliveryTrackingURL}
                        />
                      </div>
                    ) : (
                      <OrderStatusSubMessage
                        customColor={
                          appConfig.styleConfig.orderStatusSubtitleColor
                        }
                        font={appConfig.styleConfig.orderStatusMessageFont}
                      >
                        {`It will be delivered by ${orderReadyTime}`}
                      </OrderStatusSubMessage>
                    )}
                  </>
                )}
              </>
            ) : status === 2 &&
              orderType === 'drop_off' &&
              timeList[index] &&
              !timeList[index].displayComplete ? (
              <>
                Your order is ready for drop-off
                <OrderStatusSubMessage
                  customColor={appConfig.styleConfig.orderStatusSubtitleColor}
                  font={appConfig.styleConfig.orderStatusMessageFont}
                >
                  {`at ${businessName}`}
                </OrderStatusSubMessage>
              </>
            ) : status === ORDER_REFUNDED || status === ORDER_REJECTED ? (
              <div>{statusMessage}</div>
            ) : status === ORDER_COMPLETE &&
              timeList[index] &&
              timeList[index].displayComplete ? (
              <div>Your order is complete!</div>
            ) : null}
          </OrderStatusMessage>
        )}
      </ContentWrapper>
    );
  };
  return (
    <div style={{ width: '67vw' }}>
      <SliderWrapper isMultiple={isMultiple} feedbackRef={feedbackRef}>
        {orderStatusList.map((orderStatus, index) => {
          const status = orderStatus.status;
          const businessName = orderStatus.business_name;
          const orderType = orderStatus.order_type;
          const orderReadyTime = calculateOrderReadyTime(orderStatus, false);
          const minPrepTime = moment
            .duration(orderStatus.min_prep_time, 'HH:mm:ss')
            .asMinutes();

          const deliveryTrackingURL = orderStatus.delivery_tracking_url;
          const delay = orderStatus.delay;
          const statusMessage = orderStatus?.status_change_message
            ? orderStatus.status_change_message
            : ' Unfortunately, we cannot fulfill your order at this time. Your order will be refunded.';
          return (
            <OrderStatusContainer key={index}>
              <OrderStatusWrapper
                onClick={() => {
                  isOrderWithFirebaseUrl(orderHistory, orderStatus);
                  setDisplayComplete(timeList[index].displayComplete);
                  setOrderStatusModalData(orderStatus);
                }}
                isForModal={
                  isOrderWithFirebaseUrl(orderHistory, orderStatus)
                    ? false
                    : true
                }
                key={index}
              >
                <Title id='OrderStatus-Title'>Order Status</Title>
                <OrderStatusBody
                  orderType={orderType}
                  status={status}
                  businessName={businessName}
                  orderReadyTime={orderReadyTime}
                  deliveryTrackingURL={deliveryTrackingURL}
                  delay={delay}
                  index={index}
                  statusMessage={statusMessage}
                  isFutureOrder={orderStatus.is_future_order}
                  minPrepTime={minPrepTime}
                />
              </OrderStatusWrapper>
              {orderStatusList?.length > 1 && (
                <OrderPlacedTimeWrapper>
                  {`Placed on: ${moment(orderStatus?.order_created_at).format(
                    'MMMM Do, hh:mm A'
                  )}`}
                </OrderPlacedTimeWrapper>
              )}
              {appConfig.appSource !== 'madradish' &&
              (status === ORDER_COMPLETE ||
                status === ORDER_ON_DELIVERY ||
                ([0, 1, 2, 4, 5].includes(status) &&
                  appConfig.styleConfig.isStaticOrderStatus)) ? (
                <FeedbackWrapper ref={feedbackRef}>
                  <RateTextWrapper>
                    <i
                      className='fal fa-user-headset'
                      style={{ lineHeight: '40px' }}
                    ></i>
                    <span style={{ display: 'inline-block' }}>
                      Tell us how we did today. Your feedback helps us improve.
                    </span>
                  </RateTextWrapper>
                  <ButtonWrapper>
                    <Button
                      id='OrderStatus-FeedbackButton'
                      onClick={() => {
                        setFeedbackModalData(orderStatus);
                        setIsFavoriteOpen(true);
                      }}
                    >
                      Rate your order
                    </Button>
                  </ButtonWrapper>
                </FeedbackWrapper>
              ) : null}
            </OrderStatusContainer>
          );
        })}
      </SliderWrapper>
      <FeedbackModal
        feedbackModalData={feedbackModalData}
        setFeedbackModalData={setFeedbackModalData}
        sendReview={sendReview}
        feedbackModalIsVisible={feedbackModalIsVisible}
        openFeedbackModal={openFeedbackModal}
        closeFeedbackModal={closeFeedbackModal}
        isFavoriteOpen={isFavoriteOpen}
        setIsFavoriteOpen={setIsFavoriteOpen}
      />
      <OrderStatusModal1
        orderStatusModalData={orderStatusModalData}
        setOrderStatusModalData={setOrderStatusModalData}
        isMultiple={isMultiple}
        currency={currency}
        is_tip_enabled={is_tip_enabled}
        displayComplete={displayComplete}
        locations={locations}
      />
    </div>
  );
};

export default memo(OrderStatus1);
